import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import './scrollbar.css';
// Start app_ready_time trace as early as possible (right after Firebase init)
// This will be stopped when auth is ready (in AuthContext)
import { startAppReadyTime } from "./utilities/perfTraces";
startAppReadyTime();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);